import React from 'react';
import { Hero } from './components/Hero';
import { ProblemAgitation } from './components/ProblemAgitation';
import { FailedAttempts } from './components/FailedAttempts';
import { Solution } from './components/Solution';
import { Deliverables } from './components/Deliverables';
import { WhoIsItFor } from './components/WhoIsItFor';
import { ThreeSteps } from './components/ThreeSteps';
import { Transformation } from './components/Transformation';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-black text-white selection:bg-brand-neon selection:text-black" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemAgitation data-id="element-2" />
      <FailedAttempts data-id="element-3" />
      <Solution data-id="element-4" />
      <Deliverables data-id="element-5" />
      <WhoIsItFor data-id="element-6" />
      <ThreeSteps data-id="element-7" />
      <Transformation data-id="element-8" />
      <FAQ data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}